const CHUNK_ERROR_PATTERNS = [
  'failed to fetch dynamically imported module',
  // Firefox wording for the same failed import()
  'error loading dynamically imported module',
  'importing a module script failed',
  'failed to load module script',
  'loading chunk',
  'chunkloaderror',
  'unable to preload css',
  // TanStack Router tries to access .component on a module that failed to load → undefined
  "cannot read properties of undefined (reading 'component')",
  "cannot read properties of undefined (reading 'loader')",
  // Firefox spells the same TypeError as: can't access property "component", e is undefined
  'can\'t access property "component"',
  'can\'t access property "loader"',
];

// Safari spells the same router failure as: undefined is not an object (evaluating 'e.component').
// Matched by regexp, not by substring: the bare "undefined is not an object (evaluating" prefix
// covers every ordinary TypeError in Safari, and a stale-bundle reload must not swallow real bugs.
// The object name is minified and changes every build, hence [^']*.
// Второй вариант той же поломки: у TanStack там, где мы читаем компонент из модуля, доступ
// вычисляемый — `res[exportName ?? 'default']`, — и минификатор оставляет его как есть. Safari
// печатает выражение целиком: undefined is not an object (evaluating 'e[t??`default`]').
//
// Якорь на `?? default` обязателен. Без него — то есть по любому скобочному доступу — сюда
// попадал бы каждый обычный TypeError вида 'a[b]', и настоящая регрессия молча превращалась бы
// в «идёт обновление» с перезагрузкой вместо честного отчёта.
//
// Это подстраховка, а не лечение: после того как client.tsx перестал глушить провал импорта,
// модуль приходит нормальным реджектом и до TypeError дело не доходит. Остаются вкладки со
// сборкой до этой правки и любой будущий глушитель реджекта.
const CHUNK_ERROR_REGEXPS = [
  /undefined is not an object \(evaluating '[^']*\.(component|loader)'\)/,
  /undefined is not an object \(evaluating '[^']*\[[^']*\?\?\s*[`'"]default[`'"]\]'\)/,
];

export const isChunkLoadError = (error: unknown): boolean => {
  if (!error) {
    return false;
  }

  const message =
    typeof error === 'string'
      ? error
      : typeof (error as { message?: unknown }).message === 'string'
        ? (error as { message: string }).message
        : '';

  if (!message) {
    return false;
  }

  const normalized = message.toLowerCase();

  return (
    CHUNK_ERROR_PATTERNS.some((pattern) => normalized.includes(pattern)) ||
    CHUNK_ERROR_REGEXPS.some((pattern) => pattern.test(normalized))
  );
};
